/**
 *
 * Asynchronously loads the component for SubmissionsPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const SubmissionsPage = lazyLoad(
  () => import('./index'),
  module => module.SubmissionsPage,
);
